import { render } from "./Loading.vue?vue&type=template&id=0d4dc072"
const script = {}
script.render = render

export default script